import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./VisitorDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"
import axios from 'axios'
import { wtc5214 ,visitor8082} from '../Network/Config'

function VisitorOrganizeCarAddUser(props) {
    console.log(props.company);
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();
    const { carID } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");

    const [securityVisitor, setSecurityVisitor] = useState([])
    const [userFirstName, setUserFirstName] = useState("");
    const [userLastName, setUserLastName] = useState("");
    const [companyName, setCompanyName] = useState("")
    const [isError, setError] = useState(false);


    const [role, setRole] = useState([])

    useEffect(() => {
        setDocumentTitle("Create Security")
    }, [])


    const onSubmit = () =>{
        if( !userFirstName ,!userLastName ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);
        updateSecurity(userFirstName, userLastName);
    }
    
    const updateSecurity = async (userFirstName, userLastName) =>{
        const formDataUpdate = new FormData();
        formDataUpdate.append('company_name', props.company);
        formDataUpdate.append('car_id', carID);
        formDataUpdate.append('firstname', userFirstName);
        formDataUpdate.append('lastname', userLastName);
        const responseData = await axios.post(visitor8082+'/visitor/api/v1/adduser_bycar_id', formDataUpdate);
        setLoading(false)
        history.push("/visitor_organize_car")
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={'เพิ่มคนบนทะเบียน '+ carID} isShowBack backTo="/visitor_organize_car"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{'ชื่อจริง'}</Form.Label>
                            <Form.Control
                            placeholder="ชื่อจริง"
                            value={userFirstName}
                            isInvalid={isError && !userFirstName}
                            onChange={(e)=>setUserFirstName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'นามสกุล'}</Form.Label>
                            <Form.Control
                            placeholder="นามสกุล"
                            value={userLastName}
                            isInvalid={isError && !userLastName}
                            onChange={(e)=>setUserLastName(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{'บันทึกการเพิ่มคน'}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default VisitorOrganizeCarAddUser
